module.exports = __webpack_public_path__ + "media/images/wfc/city-3-697445ad4dd69cbc5ee9920f6040d43f.jpg";